import axiosInterceptor from "../helpers/Interceptor";
import { APIs } from "../constants/Constants";

// One in-flight request per session, kept as a promise so concurrent callers
// share it instead of each firing their own. Cleared on failure so a later
// attempt can retry.
let _credentialsPromise = null;

/**
 * Fetches the RAI service-account credentials from our backend, which reads
 * them from its own environment. They are no longer shipped to the browser in
 * env-config.js or baked into the bundle.
 *
 * The endpoint requires an authenticated session, and this is only called at
 * the point a Gizmo page actually needs to talk to RAI.
 *
 * @returns {Promise<{username: string, password: string, projectID: string}|null>}
 */
export const fetchRaiCredentials = () => {
  if (!_credentialsPromise) {
    _credentialsPromise = axiosInterceptor
      .get(APIs.RAICREDENTIALS)
      .then((response) => response?.data || null)
      .catch((error) => {
        _credentialsPromise = null; // allow a retry on the next call
        console.error("Could not fetch RAI credentials.", error);
        return null;
      });
  }
  return _credentialsPromise;
};
